import { useTranslation } from "react-i18next";
import { AttachmentIcon } from "../components/icons/AttachmentIcon.component";
import type { AssetInterface } from "@ihr-radioedit/inferno-core";
import { getMediaServerUrl } from "@ihr-radioedit/inferno-core";
import { MagicLink } from "../ui";
import "./DocumentAsset.style.scss";
import AssetCaption from "./AssetCaption.component";

interface DocumentAssetProps {
  imageHost: string;
  asset: AssetInterface;
}

export const DocumentAsset = (props: DocumentAssetProps) => {
  const { t } = useTranslation();
  const defaultTitle = t("asset_cta", { type: t("document") });
  const docUrl = `${getMediaServerUrl(props.imageHost, props.asset.bucket, props.asset.id)}?passthrough=1`;

  return (
    <div className="component-document-asset">
      <div className="icon">
        <MagicLink to={docUrl} target="_blank">
          <AttachmentIcon />
        </MagicLink>
      </div>
      <div className="title">
        <h2>
          <MagicLink to={docUrl} target="_blank">
            {props.asset.title || defaultTitle}
          </MagicLink>
        </h2>
      </div>
      <AssetCaption {...props.asset} assetType="document" />
    </div>
  );
};
export default DocumentAsset;
